
export const name = "payments-ui-app";
export const version = "dev";
